// Stub for orders WebSocket service - replace with actual implementation
export const ordersWs = {
  connect: () => {},
  disconnect: () => {},
  subscribe: (_config: any) => {},
  unsubscribe: (_userId: string) => {},
  onOrderUpdate: (_callback: (data: any) => void) => () => {},
  initialize: () => {},
};
